// src/Admin copy/api/dashboardApi.js
import axios from 'axios';
const apiBase = process.env.REACT_APP_API

export const getStats = async (timePeriod = 'week') => {
  try {
    const response = await axios.get(`${apiBase}/api/stats/flash?timePeriod=${timePeriod}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`, // Pass JWT token in headers
      },
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    throw error;  // Rethrow error to handle it in the component
  }
};

export const fetchMonthlyIncome = async () => {
  try {
    const response = await axios.get(`${apiBase}/api/stats/income/by/month`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching income data:", error);
    return null;
  }
};

export const fetchDashboardStats = async (period = 'week') => {
  try {
    // Handle 'all' period which uses total revenue instead of period-specific revenue
    const queryPeriod = period === 'all' ? 'year' : period; // Use 'year' for API but will show total_revenue
    
    // Try the new analytics endpoint first
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${apiBase}/analytics/dashboard/stats?period=${queryPeriod}`, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      });
      
      const stats = response.data.stats;
      
      // For 'all' period, ensure we display no percentage change
      if (period === 'all') {
        stats.revenue_change_percentage = 0;
      }
      
      return stats;
    } catch (analyticsError) {
      console.log("Analytics API failed, falling back to legacy endpoint:", analyticsError);
    }
    
    // Fallback to the old endpoint
    const token = localStorage.getItem("token");
    const response = await fetch(`${apiBase}/admin/dashboard`, {
      method: "GET",
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw response;
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

export const fetchQuotaStats = async (startDate, endDate) => {
  try {
    const response = await fetch(
      `${apiBase}/analytics/dashboard/quota/stats?startDate=${startDate}&endDate=${endDate}`
    );
    
    if (!response.ok) {
      throw new Error(`API call failed with status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching quota stats:', error);
    throw error;
  }
};

export const fetchSmsBalance = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${apiBase}/analytics/dashboard/sms/balance`, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching SMS balance:", error);
    throw error;
  }
};